import React from 'react';

const NewOrderIncompleteRequest = (props) => {
  return <div>{props.message}</div>;
};

export default NewOrderIncompleteRequest;
